module.exports = __webpack_public_path__ + "media/images/front/icons/like_on-2dbcca3c65814eacb334edd85b816277.png";